import React, { JSX, useEffect, useState } from 'react';

import ItemsCounter from './ItemsCounter';
import Styles from './ServiceOptionCard.module.scss';
import RichText from '../../../richtext';
import { RecommendedOptionsTranslations } from '../../types';
import { getTranslation } from '../../RecommendedOptionsUtils';
import { GAEVENT, CTATEXTCLICK } from '../../../../Analytics/AnalyticsConstants';

interface ServiceDetailsSectionInterface {
  text: string;
  size?: number;
  init?: boolean;
  setIsDetailsOverlay: React.Dispatch<React.SetStateAction<boolean>>;
  isDetailsOverlay: boolean;
  setCardOverlayDetails: React.Dispatch<React.SetStateAction<any[]>>;
  content: any;
  setShowpop: React.Dispatch<React.SetStateAction<boolean>>;
  serviceOptions: any[];
  handleClick: any;
  description: any;
  detailsBtn: boolean;
  checked?: boolean;
  translations: RecommendedOptionsTranslations;
  cartLoading?: boolean;
}

const ServiceDetailsSection = ({
  content,
  text,
  size = 100,
  init = true,
  setIsDetailsOverlay,
  isDetailsOverlay,
  setCardOverlayDetails,
  setShowpop,
  serviceOptions,
  handleClick,
  description,
  checked,
  translations,
  cartLoading
}: ServiceDetailsSectionInterface): JSX.Element => {
  const [isLess, onToggle] = useState(init);
  const [count, setCount] = useState<number>(0);

  //on change of count
  useEffect(() => {
    if (content?.code === 'HZN TV MultiBox') {
      if (!checked) {
        setCount(0);
      } else if (checked && count === 0) {
        setCount(1);
      }
    } else if (content.count !== count) {
      setCount(count);
    }
  }, [count, checked]);

  //inital count set up
  useEffect(() => {
    const itemCount = getItemsQuantity(serviceOptions, content);
    if (itemCount > 0) {
      setCount(itemCount);
    } else {
      setCount(0);
    }
  }, [serviceOptions]);

  const getItemsQuantity = (serviceOptions: any, content: any) => {
    return serviceOptions.filter((item: any) => item.id === content?.code).length;
  };
  if (text?.length < size) return <div className={Styles.description}>{text}</div>;

  return (
    <>
      {(text || description) && (
        <div className={Styles.description}>
          {isLess ? text?.substring(0, size) + '...' : <RichText content={description} />}
        </div>
      )}
      {(text || description) && isLess && (
        <button
          className={`text-button ms-0 ${Styles.detailsButton}`}
          onClick={() => {
            // Track CTA text click with analytics
            try {
              if (typeof window !== 'undefined' && window.dataLayer) {
                const clickText =
                  getTranslation(translations, 'show_more_details') ?? 'Show more details';
                const headline = content?.title || content?.displayName || content?.code || '';
                const linkUrl = content?.detailsLink || '';

                window.dataLayer.push({
                  event: GAEVENT,
                  event_name: CTATEXTCLICK,
                  link_url: linkUrl,
                  click_text: clickText,
                  headline: headline
                });
              }
            } catch (error) {
              console.error('Analytics tracking error (cta_text_click):', error);
            }

            if (!isDetailsOverlay) setIsDetailsOverlay(true);
            setCardOverlayDetails([content]);
            setShowpop(false);
            onToggle(true);
          }}
        >
          {getTranslation(translations, 'show_more_details') ?? 'Show more details'}
        </button>
      )}

      {content?.additionalTVOption?.[0]?.additionalOptionRequired && (
        <div className={`mb-2  ${Styles['counter-adjust-price']}`}>
          <ItemsCounter
            count={count}
            parentCallBack={{ setCount }}
            maxLimit={parseInt(content?.additionalTVOption?.[0]?.maxValue)}
            handleClick={handleClick}
            translations={translations}
            cartLoading={cartLoading}
          />
        </div>
      )}
    </>
  );
};
export default ServiceDetailsSection;
